export default __webpack_public_path__ + "static/media/shield-star-outline.7ee566f3.svg";